module.exports = __webpack_public_path__ + "static/img/7.99b5c0c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/eng/7.png
// module id = T772
// module chunks = 0